<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(header, n) in headers" :key="n">{{campaignType !== 'CVPIP' ? header : header !== 'UV' ? header : 'SKIP'}}</th>
    </tr>
    <tbody>
      <tr v-for="(contract, index) in contractData" :key="index">
        <td>
          {{contract.ad_knd_nm}}
        </td>
        <!-- 광고상품 -->
        <td>
          {{contract.dp_knd_nm}}
        </td>
        <!-- 노출방법 => 타겟팅으로 수정 19.10.07 -->
        <td>
          <div class="data_wrap">{{parseDataType(contract.contract_imp)}}</div>
        </td>
        <!-- 계약수
        <td>
          <div class="data_wrap">{{contract.cpvc_goal}}</div>
        </td>
        CPVC 목표단가 -->
       <!-- <td>
          <div class="data_wrap">{{contract.cpvc_avg}}</div>
        </td>
        CPVC 평균단가 -->
        <td>
          <div class="data_wrap">{{parseDataType(contract.imp_cnt)}}</div>
        </td>
        <!-- 노출수 -->
        <td>
          <div class="data_wrap">{{parseDataType(contract.view_cnt)}}</div>
        </td>
        <!-- VIEW -->
        <td>
          <div class="data_wrap">{{contract.vtr.toFixed(1)}}</div>
        </td>
        <!-- VTR(%) -->
        <td>
          <div class="data_wrap">{{parseDataType(contract.click_cnt)}}</div>
        </td>
        <!-- 클릭수 -->
        <td>
          <div class="data_wrap">{{contract.ctr.toFixed(2)}}</div>
        </td>
        <!--  CTR(%) -->
        <!-- <td>
          <div class="data_wrap">{{parseDataType(contract.cpvc)}}</div>
        </td>
        VIEW + CLICK -->
        <td>
          <div class="data_wrap">{{parseData(contract.day_rate, 'rate')}}</div>
        </td>
        <!-- 진행률(%) -->
        <td>
          <div class="data_wrap">{{parseData(contract.imp_rate, 'rate')}}</div>
        </td>
        <!-- 달성률(%) -->
        <td>
          <div class="data_wrap">
            {{campaignType !== 'CVPIP' ? parseDataType(contract.uv_cnt) : parseDataType(contract.skip_cnt)}}
          </div>
        </td>
        <!-- UV -->
        <td>
          <div class="data_wrap">{{parseData(contract.play_sec_avg, 'rate')}}</div>
        </td>
        <!-- 평균재생(초) -->
        <td>
          <div class="data_wrap">{{parseData(contract.end_rate, 'rate')}}</div>
        </td>
        <!-- 재생완료(%) -->
        <td>
          <div class="data_wrap">{{parseData(contract.play_Q1_rate, 'rate')}}</div>
        </td>
        <!-- 재생Q1(%) -->
        <td>
          <div class="data_wrap">{{parseData(contract.play_Q2_rate, 'rate')}}</div>
        </td>
        <!-- 재생Q2(%) -->
        <td>
          <div class="data_wrap">{{parseData(contract.play_Q3_rate, 'rate')}}</div>
        </td>
        <!-- 재생Q3(%) -->
        <td>
          <div class="data_wrap">{{parseDataType(contract.budget_amt)}}</div>
        </td>
        <!-- 총 광고비 -->
      </tr>
      <tr>
        <td colspan="5" class="contract_total_text cv_table"><b>합계</b></td>
        <th>
          <div class="data_wrap">{{parseDataType(contractTotal.imp_cnt)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{parseDataType(contractTotal.view)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{contractTotal.vtr.toFixed(1)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{parseDataType(contractTotal.click_cnt)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{contractTotal.ctr.toFixed(2)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{parseDataType(contractTotal.vc)}}</div>
        </th>
        <th>
          <div class="data_wrap">{{contractTotal.day_rate}}</div>
        </th>
        <th>
          <div class="data_wrap">{{contractTotal.imp_rate.toFixed(1)}}</div>
        </th>
        <th><div></div></th>
        <th><div></div></th>
        <th><div></div></th>
        <th>
          <div class="data_wrap">{{contractTotal.budget_amt}}</div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseData } from '@/assets/func'
  export default {
    name: 'contractInterPlayCPV',
    props: {
      campaignType: String,
      contractData: Array,
      contractTotal: Object,
      parseDataType: Function
    },
    data () {
      return {
        headers: [
          '광고상품',
          '타겟팅',
          '계약수',
          '노출수',
          'VIEW',
          'VTR(%)',
          '클릭수',
          'CTR(%)',
          '진행률(%)',
          '달성률(%)',
          'UV',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)',
          '총 광고비'
        ]
      }
    },
    methods: {
      parseData (data, key) {
        return parseData(data, key)
      }
    }
  }
</script>

<style scope>
  td {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// ContractInterPlayCPV.vue?5b303360